import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
// import LeaderBoardHero from "components/LeaderBoardHero/LeaderBoardHero";
// import LeaderBoardPopular from "components/LeaderBoardPopular/LeaderBoardPopular";
// import LeaderBoardTopSelling from "components/LeaderBoardPopular/LeaderBoardTopSelling";
import TopPlayers from "components/LeaderBoardPopular/TopPlayers";
import { HERO_SECTION, EMPTY_MARKET_PLACE } from "src/constants/images";
import LeaderBoardSkeleton from "components/Loader/LeaderBoardSkeleton/LeaderBoardSkeleton";
import SEO from "components/SEO";
import {
  fetchAnalyistsData,
  fetchLatestDetectiveData,
  fetchLatestUpdatedGangstersData,
  fetchSkillGangstersData,
  fetchPopularGangsterByClass,
  fetchPopularDetectiveByClass,
  fetchPopularGangsterByLevel,
  fetchPopularDetectiveByLevel,
} from "../redux/actions/leaderboard";
import { fetchLatestGangstersData } from "../redux/actions/home";
import { replaceFloatValue } from "utils/replaceFloatValue";
import { MARKET_PLACE } from "src/constants/routes";
import TopDetectives from "components/Alleyway/TopDetectives";
import TopGangster from "components/Alleyway/TopGangster";
import { highestSoldNFT } from "api/api";
import GangstaCard from "components/GangstaCard/GangstaCard";
import LeaderBoardPopularSkeleton from "components/Loader/LeaderBoardSkeleton/LeaderBoardPopularSkeleton";
import {
  fetchFilterData,
  fetchAccumulatedGBETs,
} from "../redux/actions/marketplace";

const Alleyway = () => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  const {
    gangstersData,
    detectivesData,
    isGangstersLoading,
    isDetectivesLoading,
    isFilterPopularGangsterLoading,
    filteredGangsterClassData,
    isFilterPopularDetectiveLoading,
    filteredDetectiveClassData,
    filteredGangsterLevelData,
    filteredDetectiveLevelData,
  } = useSelector((state) => state.leaderboard);
  const { updatedGangstersData } = useSelector((state) => state.home);
  const [DetectiveActiveFilter, setDetectiveActiveFilter] = useState(null);
  const [GangsterActiveFilter, setGangsterActiveFilter] = useState(null);

  const icxInUSD = useSelector((state) => state.icxPricing.price);
  const [highestSoldNfts, setHighestSoldNfts] = useState([]);

  const { filterData, accumulatedGBETs, isAccumulatedGBETLoading } =
    useSelector((state) => state.marketplace);
  useEffect(() => {
    if (GangsterActiveFilter?.includes("Type")) {
      dispatch(
        fetchPopularGangsterByClass(
          GangsterActiveFilter?.split("-").splice(1).join("-"),
          1
        )
      );
    } else if (GangsterActiveFilter?.includes("Level")) {
      dispatch(
        fetchPopularGangsterByLevel(
          GangsterActiveFilter?.split("-").splice(1).join("-"),
          1
        )
      );
    }
  }, [GangsterActiveFilter]);
  useEffect(() => {
    if (DetectiveActiveFilter?.includes("Type")) {
      dispatch(
        fetchPopularDetectiveByClass(
          DetectiveActiveFilter?.split("-").splice(1).join("-"),
          1
        )
      );
    } else if (DetectiveActiveFilter?.includes("Level")) {
      dispatch(
        fetchPopularDetectiveByLevel(
          DetectiveActiveFilter?.split("-").splice(1).join("-"),
          1
        )
      );
    }
  }, [DetectiveActiveFilter]);
  useEffect(() => {
    setLoading(false);
    dispatch(fetchLatestGangstersData(1));
    dispatch(fetchAnalyistsData());
    dispatch(fetchLatestUpdatedGangstersData(1));
    dispatch(fetchLatestDetectiveData(1));
    dispatch(fetchSkillGangstersData(1));
    getHightestNfts();
    dispatch(fetchFilterData());
  }, []);
  // useEffect(() => {
  //   dispatch(fetchAccumulatedGBETs(highestSoldNfts));
  // }, [highestSoldNfts]);
  const pageMetaData = {
    pageTitle: `Leaderboard | GangstaBet: A Digital Collectible  `,
    pageDescription: null,
    pageKeywords: null,
    pageImage: null,
  };

  async function getHightestNfts() {
    try {
      setLoading(true);
      const res = await highestSoldNFT();

      setHighestSoldNfts(res.data.tokens);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }
  return (
    <SEO pageMetaData={pageMetaData}>
      <div className="container alleyway-main">
        <h2>LeaderBoard</h2>
        {gangstersData.length !== 0 || updatedGangstersData.length !== 0 ? (
          <>
            <div className="alley-topGangstabets container">
              <div className="top-block gangster">
                <TopGangster
                  isLoading={
                    isFilterPopularGangsterLoading || isGangstersLoading
                  }
                  filterData={filterData}
                  gangstersData={
                    GangsterActiveFilter
                      ? GangsterActiveFilter?.includes("Type")
                        ? filteredGangsterClassData
                        : filteredGangsterLevelData
                      : gangstersData
                  }
                  GangsterActiveFilter={GangsterActiveFilter}
                  setGangsterActiveFilter={setGangsterActiveFilter}
                />
              </div>
              <div className="top-block detective">
                <TopDetectives
                  isLoading={
                    isFilterPopularDetectiveLoading || isDetectivesLoading
                  }
                  DetectiveActiveFilter={DetectiveActiveFilter}
                  setDetectiveActiveFilter={setDetectiveActiveFilter}
                  filterData={filterData}
                  detectivesData={
                    DetectiveActiveFilter
                      ? DetectiveActiveFilter?.includes("Type")
                        ? filteredDetectiveClassData
                        : filteredDetectiveLevelData
                      : detectivesData
                  }
                />
              </div>
              {/* <LeaderBoardHero />
            <LeaderBoardPopular /> */}
              {/* <LeaderBoardTopSelling /> */}
              {/* <TopPlayers /> */}
              {/* <LeaderInfo
              heading="See All Popular Gangstar"
              icxInUSD={icxInUSD}
              data={analysticsData}
            /> */}
            </div>

            {highestSoldNfts.length > 0 && !loading ? (
              <div className="container">
                <div>
                  {highestSoldNfts.length > 0 ? (
                    <div className="sold-title">
                      <h3>Top Sold GangstaBets</h3>
                    </div>
                  ) : null}

                  <div className="row">
                    {highestSoldNfts?.length !== 0 ? (
                      !loading &&
                      highestSoldNfts?.map((item, index) => (
                        <GangstaCard
                          name={item.token_name}
                          image={item.token_uri}
                          key={index}
                          number={item.number}
                          stats={item.total_stats}
                          type={item.type}
                          accumulatedGBET={null}
                          isAccumulatedGBETLoading={false}
                          class_type={item.class_type}
                          isGangster={item.isGangster}
                          id={item._id}
                          for_sale={item.for_sale}
                          totalPrice={item.total_price_sold}
                        />
                      ))
                    ) : (
                      <LeaderBoardPopularSkeleton />
                    )}
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </>
        ) : isGangstersLoading && loading && isDetectivesLoading ? (
          <LeaderBoardSkeleton />
        ) : (
          <div className="text-center align-self-center py-5 empty-leaderboard">
            <img src={EMPTY_MARKET_PLACE.SOURCE} alt="empty market-place" />
            <h3 className="mb-1 title">Coming Soon..</h3>
            <p className="mb-1 no-data">GangstaBets will appear soon.</p>
          </div>
        )}
      </div>
    </SEO>
  );
};

export default Alleyway;
